import { pxToNumber, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const DuplicateBillsTableWrapper = styled.div`
  display: flex;
  margin-top: ${Spacing.S6};
`

export const DuplicateBillsLabel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S40};
  margin: ${pxToNumber(Spacing.S32) + pxToNumber(Spacing.S40)}px ${Spacing.S24} 0;
`
